<template>
  <div
    class="portfolio-container"
    v-if="path && path"
    :class="[path === 'home' ? 'borderTop' : '']"
  >
    <div v-if="path === 'Portfolio'">
      <h2 class="sub-heading">our achievements</h2>
      <span class="line"></span>
      <div class="block-display">
        <div class="flex">
          <button
            @click="changeFilter('all')"
            :class="{ active: isCurrent === 'all' }"
          >
            all
          </button>
          <button
            @click="changeFilter('web')"
            :class="{ active: isCurrent === 'web' }"
          >
            web develpment
          </button>
          <button
            @click="changeFilter('app')"
            :class="{ active: isCurrent === 'app' }"
          >
            app Development
          </button>
          <button
            @click="changeFilter('design')"
            :class="{ active: isCurrent === 'design' }"
          >
            UI/UX design
          </button>
          <button
            @click="changeFilter('marketing')"
            :class="{ active: isCurrent === 'marketing' }"
          >
            Marketing
          </button>
        </div>
      </div>
    </div>
    <div class="row pt-5 mb" v-if="path === 'home'">
      <div
        class="text-center"
        :class="[path === 'home' ? 'border-short-bottom' : '']"
      >
        <h3 class="text-uppercase">{{ title }}</h3>
      </div>
      <div class="portfolio-header-desc-container">
        <p class="portfolio-header-desc" v-if="path === 'Portfolio'">
          Learn how our high-performing teams are partnering with business
          executives, entrepreneurs, and technology experts who are pursuing
          software-driven innovation.
        </p>
      </div>
    </div>
    <div class="portfolio-card-container custom-grid">
      <div
        :class="[
          path === 'Portfolio'
            ? 'portfolio-card-image-container col-sm-12 col-md-12 col-lg-4'
            : 'portfolio-card-home-image-container col-sm-12 col-md-12 col-lg-4',
        ]"
        v-for="(project, index) in filteredProjects"
        :key="project.id"
      >
        <div class="portfolio-card-body" v-if="path === 'home' && index < 3">
          <div class="portfolio-image-container">
            <img
              :src="
                require(`../../public/assets/img/portfolio/projects/${project.image}`)
              "
              alt=""
              class="portfolio-card-body-image"
            />
            <div class="overlay">
              <div class="portfolio-technology-container">
                <div
                  class="portfolio-technology-inner-container"
                  v-for="(technology, index) in project.technologyUsed"
                  :key="index"
                >
                  <img
                    src="../../public/assets/img/portfolio/Technology.svg"
                    alt=""
                  />
                  <span v-html="technology"></span>
                </div>
              </div>
              <router-link :to="`${project.path}`" class="case-study-button">
                <p>See Case Study</p>
                <span
                  ><svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.7534 22.8678C18.303 22.8678 22.8018 18.369 22.8018 12.8194C22.8018 7.26982 18.303 2.771 12.7534 2.771C7.20384 2.771 2.70502 7.26982 2.70502 12.8194C2.70502 18.369 7.20384 22.8678 12.7534 22.8678Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.7534 16.8388L16.7728 12.8194L12.7534 8.80005"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.73407 12.8195H16.7728"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </router-link>
            </div>
          </div>
          <span class="portfolio-project-name">{{ project.project_name }}</span>
          <p class="portfolio-project-short-desc">
            {{ project.short_desc.split(".")[0] + "." }}
          </p>
        </div>
        <div class="portfolio-card-body" v-if="path === 'Portfolio'">
          <div class="portfolio-image-container">
            <img
              :src="
                require(`../../public/assets/img/portfolio/projects/${project.image}`)
              "
              alt=""
              class="portfolio-card-body-image"
            />
            <router-link :to="`${project.path}`">
              <div class="overlay">
                <div class="portfolio-technology-container">
                  <div
                    class="portfolio-technology-inner-container"
                    v-for="(technology, index) in project.technologyUsed"
                    :key="index"
                  >
                    <img
                      src="../../public/assets/img/portfolio/Technology.svg"
                      alt=""
                    />
                    <span v-html="technology"></span>
                  </div>
                </div>
                <router-link :to="`${project.path}`" class="case-study-button">
                  <p>See Case Study</p>
                  <span
                    ><svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7534 22.8678C18.303 22.8678 22.8018 18.369 22.8018 12.8194C22.8018 7.26982 18.303 2.771 12.7534 2.771C7.20384 2.771 2.70502 7.26982 2.70502 12.8194C2.70502 18.369 7.20384 22.8678 12.7534 22.8678Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.7534 16.8388L16.7728 12.8194L12.7534 8.80005"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.73407 12.8195H16.7728"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </router-link>
              </div>
            </router-link>
          </div>

          <router-link :to="`${project.path}`">
            <span class="portfolio-project-name">{{
              project.project_name
            }}</span>
          </router-link>

          <p class="portfolio-project-short-desc">
            {{ project.short_desc.split(".")[0] + "." }}
          </p>
        </div>
      </div>
    </div>
    <div class="show-more-btn-container" v-if="path === 'Portfolio'">
      <button @click="downloadFile">See Complete Portfolio</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Portfolio",
  props: {
    title: {
      type: String,
      Default: "",
    },
    path: {
      type: String,
      Default: "",
    },
  },
  data() {
    return {
      projects: [
        {
          id: 1,
          tech: ["web", "marketing"],
          image: "bigscoot.png",
          project_name: "BigScoots",
          short_desc: `BigScoots is an IT organization that provides web hosting and server management.`,
          path: "/bigscoots",
          technologyUsed: [
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_308_753)">
<path d="M16.4641 16.1391L12.0391 8.28076L16.5724 16.3641C16.5391 16.2891 16.5057 16.2141 16.4641 16.1391Z" fill="black"/>
<path d="M16.468 16.023L16.4609 16.0107L16.4636 16.016L16.468 16.023Z" fill="black"/>
<path d="M16.5786 16.3893C16.612 16.481 16.6453 16.5726 16.662 16.6726H16.737L16.5786 16.3893ZM6.08698 16.6726V16.656C6.12031 16.4726 6.17865 16.306 6.26198 16.156L10.5786 8.48096L5.94531 16.6726H6.08698Z" fill="black"/>
<path d="M11.3635 7.08929L10.6885 8.28096L8.38847 4.18929L1.36346 16.6726H5.9468L5.93846 16.681C5.63846 17.206 6.0218 17.856 6.6218 17.856H1.28013C0.655131 17.856 0.371798 17.581 0.238465 17.3476C-0.0523688 16.8401 0.246798 16.2643 0.305131 16.1568L7.4218 3.51429C7.73013 2.97262 8.10513 2.85596 8.3718 2.85596C8.9543 2.85596 9.2968 3.40596 9.35513 3.50596L11.3635 7.08929Z" fill="#41B883"/>
<path d="M8.37217 2.85596C8.1055 2.85596 7.7305 2.97262 7.42217 3.51429L0.305501 16.156C0.247168 16.2643 -0.0528324 16.8393 0.238834 17.3468C0.372168 17.581 0.655501 17.856 1.2805 17.856H6.62217C6.02217 17.856 5.63883 17.206 5.93883 16.681L5.94717 16.6726H1.36383L8.38883 4.18929L8.39467 4.20012V2.85596C8.388 2.85596 8.3805 2.85596 8.37217 2.85596Z" fill="#39A072"/>
<path d="M16.7447 16.681L16.7364 16.6727H16.6614C16.6447 16.5727 16.6122 16.481 16.5789 16.3894L16.5706 16.3644L12.0372 8.28102L11.3614 7.08936L10.6864 8.28102L10.5781 8.48102L6.2614 16.156C6.1789 16.3052 6.11974 16.4727 6.0864 16.656V16.6727H5.94474L5.9364 16.681C5.6364 17.206 6.01974 17.856 6.61974 17.856H16.0614C16.6614 17.856 17.0364 17.206 16.7447 16.681ZM7.3114 16.6727L11.3614 9.47186L15.4114 16.6727H7.3114Z" fill="#35495E"/>
<path d="M11.3614 7.08936L10.6864 8.28102L10.5781 8.48102L6.2614 16.156C6.1789 16.3052 6.11974 16.4727 6.0864 16.656V16.6727H5.94474L5.9364 16.681C5.6364 17.206 6.01974 17.856 6.61974 17.856H11.3614V16.6727H7.3114L11.3614 9.47186V7.08936Z" fill="#2E4052"/>
<path d="M19.9883 17.3227C19.6966 17.831 19.0549 17.856 18.9299 17.856H16.0633C16.6624 17.856 17.0383 17.206 16.7466 16.681L16.7383 16.6727H18.8633L13.0799 6.42269L12.0383 8.28102L11.3633 7.08936L12.1216 5.74769C12.4216 5.20602 12.8049 5.08936 13.0716 5.08936C13.6541 5.08936 13.9966 5.63936 14.0541 5.74769L19.9041 16.156C20.2133 16.6977 20.1216 17.0894 19.9883 17.3227Z" fill="#3B8070"/>
<path d="M13.0716 5.08936C12.8049 5.08936 12.4208 5.20686 12.1216 5.74769L11.3633 7.08936L12.0383 8.28102L13.0799 6.42269L13.1066 6.47019V5.08936C13.0949 5.08936 13.0841 5.08936 13.0716 5.08936Z" fill="#336F62"/>
</g>
<defs>
<clipPath id="clip0_308_753">
<rect width="20" height="20" fill="white" transform="translate(0.113281 0.355957)"/>
</clipPath>
</defs>
</svg>
`,
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.527 19.3269C10.2878 19.3269 10.0506 19.2644 9.84098 19.1435L7.65712 17.8503C7.33079 17.6677 7.48999 17.6031 7.59752 17.566C8.03263 17.4139 8.12056 17.3793 8.58485 17.1155C8.63361 17.0876 8.69737 17.0976 8.74738 17.1272L10.4253 18.1228C10.4857 18.1558 10.572 18.1558 10.6278 18.1228L17.1699 14.3465C17.2303 14.3119 17.2699 14.2419 17.2699 14.1698V6.62086C17.2699 6.54542 17.2307 6.47832 17.1686 6.44082L10.6295 2.66739C10.5691 2.63155 10.4886 2.63155 10.4282 2.66739L3.88995 6.4404C3.8266 6.47624 3.78617 6.54667 3.78617 6.61878V14.1681C3.78617 14.2402 3.82535 14.309 3.88786 14.3432L5.67955 15.378C6.65229 15.8644 7.2466 15.2913 7.2466 14.7149V7.26435C7.2466 7.15807 7.32996 7.07597 7.43665 7.07597H8.26518C8.36854 7.07597 8.45356 7.15766 8.45356 7.26435V14.7187C8.45356 16.0157 7.74631 16.7608 6.51642 16.7608C6.138 16.7608 5.84001 16.7608 5.00814 16.3516L3.29189 15.3626C2.86762 15.1167 2.60547 14.6578 2.60547 14.1685V6.61919C2.60547 6.12782 2.86762 5.66938 3.29147 5.42682L9.84057 1.64881C10.2548 1.41459 10.805 1.41459 11.2163 1.64881L17.7571 5.42848C18.1789 5.67229 18.4427 6.12949 18.4427 6.62086V14.1702C18.4427 14.6599 18.1789 15.1167 17.7567 15.3626L11.2159 19.1402C11.0063 19.2614 10.7687 19.3235 10.5266 19.3235" fill="#21A366"/>
<path d="M12.5504 14.1245C9.68804 14.1245 9.08789 12.8104 9.08789 11.7085C9.08789 11.6039 9.17249 11.5201 9.27752 11.5201H10.1227C10.2161 11.5201 10.2949 11.588 10.3094 11.6801C10.437 12.5412 10.8171 12.9755 12.5479 12.9755C13.9266 12.9755 14.513 12.6641 14.513 11.9327C14.513 11.5118 14.3458 11.1992 12.2041 10.9896C10.4124 10.8129 9.30544 10.4182 9.30544 8.98533C9.30544 7.66542 10.419 6.87939 12.2841 6.87939C14.3788 6.87939 15.4169 7.60666 15.5478 9.1687C15.5528 9.22288 15.5332 9.27498 15.497 9.31457C15.4611 9.35208 15.4103 9.375 15.3578 9.375H14.508C14.4196 9.375 14.3425 9.31291 14.3246 9.22747C14.12 8.32183 13.6252 8.03218 12.2808 8.03218C10.7758 8.03218 10.6008 8.55605 10.6008 8.94907C10.6008 9.42543 10.8071 9.56463 12.8376 9.83345C14.8485 10.1002 15.8033 10.4769 15.8033 11.8902C15.8033 13.3147 14.6142 14.132 12.5412 14.132" fill="#21A366"/>
</svg>
`,
          ],
        },
        {
          id: 2,
          tech: ["web", "marketing"],
          image: "esgtree.png",
          project_name: "ESGTree",
          short_desc: `Accelerate ESG reporting for investors, while creating value for companies. We created this salient software contributing towards the betterment of our world.`,
          path: "/esgtree",
          technologyUsed: [
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_308_753)">
<path d="M16.4641 16.1391L12.0391 8.28076L16.5724 16.3641C16.5391 16.2891 16.5057 16.2141 16.4641 16.1391Z" fill="black"/>
<path d="M16.468 16.023L16.4609 16.0107L16.4636 16.016L16.468 16.023Z" fill="black"/>
<path d="M16.5786 16.3893C16.612 16.481 16.6453 16.5726 16.662 16.6726H16.737L16.5786 16.3893ZM6.08698 16.6726V16.656C6.12031 16.4726 6.17865 16.306 6.26198 16.156L10.5786 8.48096L5.94531 16.6726H6.08698Z" fill="black"/>
<path d="M11.3635 7.08929L10.6885 8.28096L8.38847 4.18929L1.36346 16.6726H5.9468L5.93846 16.681C5.63846 17.206 6.0218 17.856 6.6218 17.856H1.28013C0.655131 17.856 0.371798 17.581 0.238465 17.3476C-0.0523688 16.8401 0.246798 16.2643 0.305131 16.1568L7.4218 3.51429C7.73013 2.97262 8.10513 2.85596 8.3718 2.85596C8.9543 2.85596 9.2968 3.40596 9.35513 3.50596L11.3635 7.08929Z" fill="#41B883"/>
<path d="M8.37217 2.85596C8.1055 2.85596 7.7305 2.97262 7.42217 3.51429L0.305501 16.156C0.247168 16.2643 -0.0528324 16.8393 0.238834 17.3468C0.372168 17.581 0.655501 17.856 1.2805 17.856H6.62217C6.02217 17.856 5.63883 17.206 5.93883 16.681L5.94717 16.6726H1.36383L8.38883 4.18929L8.39467 4.20012V2.85596C8.388 2.85596 8.3805 2.85596 8.37217 2.85596Z" fill="#39A072"/>
<path d="M16.7447 16.681L16.7364 16.6727H16.6614C16.6447 16.5727 16.6122 16.481 16.5789 16.3894L16.5706 16.3644L12.0372 8.28102L11.3614 7.08936L10.6864 8.28102L10.5781 8.48102L6.2614 16.156C6.1789 16.3052 6.11974 16.4727 6.0864 16.656V16.6727H5.94474L5.9364 16.681C5.6364 17.206 6.01974 17.856 6.61974 17.856H16.0614C16.6614 17.856 17.0364 17.206 16.7447 16.681ZM7.3114 16.6727L11.3614 9.47186L15.4114 16.6727H7.3114Z" fill="#35495E"/>
<path d="M11.3614 7.08936L10.6864 8.28102L10.5781 8.48102L6.2614 16.156C6.1789 16.3052 6.11974 16.4727 6.0864 16.656V16.6727H5.94474L5.9364 16.681C5.6364 17.206 6.01974 17.856 6.61974 17.856H11.3614V16.6727H7.3114L11.3614 9.47186V7.08936Z" fill="#2E4052"/>
<path d="M19.9883 17.3227C19.6966 17.831 19.0549 17.856 18.9299 17.856H16.0633C16.6624 17.856 17.0383 17.206 16.7466 16.681L16.7383 16.6727H18.8633L13.0799 6.42269L12.0383 8.28102L11.3633 7.08936L12.1216 5.74769C12.4216 5.20602 12.8049 5.08936 13.0716 5.08936C13.6541 5.08936 13.9966 5.63936 14.0541 5.74769L19.9041 16.156C20.2133 16.6977 20.1216 17.0894 19.9883 17.3227Z" fill="#3B8070"/>
<path d="M13.0716 5.08936C12.8049 5.08936 12.4208 5.20686 12.1216 5.74769L11.3633 7.08936L12.0383 8.28102L13.0799 6.42269L13.1066 6.47019V5.08936C13.0949 5.08936 13.0841 5.08936 13.0716 5.08936Z" fill="#336F62"/>
</g>
<defs>
<clipPath id="clip0_308_753">
<rect width="20" height="20" fill="white" transform="translate(0.113281 0.355957)"/>
</clipPath>
</defs>
</svg>
`,
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.527 19.3269C10.2878 19.3269 10.0506 19.2644 9.84098 19.1435L7.65712 17.8503C7.33079 17.6677 7.48999 17.6031 7.59752 17.566C8.03263 17.4139 8.12056 17.3793 8.58485 17.1155C8.63361 17.0876 8.69737 17.0976 8.74738 17.1272L10.4253 18.1228C10.4857 18.1558 10.572 18.1558 10.6278 18.1228L17.1699 14.3465C17.2303 14.3119 17.2699 14.2419 17.2699 14.1698V6.62086C17.2699 6.54542 17.2307 6.47832 17.1686 6.44082L10.6295 2.66739C10.5691 2.63155 10.4886 2.63155 10.4282 2.66739L3.88995 6.4404C3.8266 6.47624 3.78617 6.54667 3.78617 6.61878V14.1681C3.78617 14.2402 3.82535 14.309 3.88786 14.3432L5.67955 15.378C6.65229 15.8644 7.2466 15.2913 7.2466 14.7149V7.26435C7.2466 7.15807 7.32996 7.07597 7.43665 7.07597H8.26518C8.36854 7.07597 8.45356 7.15766 8.45356 7.26435V14.7187C8.45356 16.0157 7.74631 16.7608 6.51642 16.7608C6.138 16.7608 5.84001 16.7608 5.00814 16.3516L3.29189 15.3626C2.86762 15.1167 2.60547 14.6578 2.60547 14.1685V6.61919C2.60547 6.12782 2.86762 5.66938 3.29147 5.42682L9.84057 1.64881C10.2548 1.41459 10.805 1.41459 11.2163 1.64881L17.7571 5.42848C18.1789 5.67229 18.4427 6.12949 18.4427 6.62086V14.1702C18.4427 14.6599 18.1789 15.1167 17.7567 15.3626L11.2159 19.1402C11.0063 19.2614 10.7687 19.3235 10.5266 19.3235" fill="#21A366"/>
<path d="M12.5504 14.1245C9.68804 14.1245 9.08789 12.8104 9.08789 11.7085C9.08789 11.6039 9.17249 11.5201 9.27752 11.5201H10.1227C10.2161 11.5201 10.2949 11.588 10.3094 11.6801C10.437 12.5412 10.8171 12.9755 12.5479 12.9755C13.9266 12.9755 14.513 12.6641 14.513 11.9327C14.513 11.5118 14.3458 11.1992 12.2041 10.9896C10.4124 10.8129 9.30544 10.4182 9.30544 8.98533C9.30544 7.66542 10.419 6.87939 12.2841 6.87939C14.3788 6.87939 15.4169 7.60666 15.5478 9.1687C15.5528 9.22288 15.5332 9.27498 15.497 9.31457C15.4611 9.35208 15.4103 9.375 15.3578 9.375H14.508C14.4196 9.375 14.3425 9.31291 14.3246 9.22747C14.12 8.32183 13.6252 8.03218 12.2808 8.03218C10.7758 8.03218 10.6008 8.55605 10.6008 8.94907C10.6008 9.42543 10.8071 9.56463 12.8376 9.83345C14.8485 10.1002 15.8033 10.4769 15.8033 11.8902C15.8033 13.3147 14.6142 14.132 12.5412 14.132" fill="#21A366"/>
</svg>
`,
          ],
        },
        {
          id: 3,
          tech: ["app", "marketing"],
          image: "znapshot.png",
          project_name: "Znapshot",
          short_desc: `Access an exclusive library from the world’s greatest & finest photographers. Znapshot brings new innovation to the world of wallpapers by introducing unique and meaningful artwork`,
          path: "/znapShot",
          technologyUsed: [
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8919 19.0321H10.8919L6.30859 14.4487L8.80859 11.9487L15.8919 19.0321Z" fill="url(#paint0_linear_308_801)"/>
<path d="M2.55859 10.6986L10.8919 2.36523H15.8919L5.05859 13.1986L2.55859 10.6986Z" fill="#50E6FF"/>
<path d="M15.8919 9.86523L8.80859 16.9486L6.30859 14.4486L10.8919 9.86523H15.8919Z" fill="#50E6FF"/>
<path d="M8.80847 11.9488L6.30859 14.4487L8.80855 16.9486L11.3084 14.4486L8.80847 11.9488Z" fill="#35C1F1"/>
<defs>
<linearGradient id="paint0_linear_308_801" x1="14.7711" y1="20.4112" x2="9.31818" y2="14.9583" gradientUnits="userSpaceOnUse">
<stop stop-color="#0176D0"/>
<stop offset="0.454" stop-color="#0275CE"/>
<stop offset="0.617" stop-color="#0472C7"/>
<stop offset="0.733" stop-color="#076BBC"/>
<stop offset="0.827" stop-color="#0D63AB"/>
<stop offset="0.907" stop-color="#135895"/>
<stop offset="0.933" stop-color="#16538C"/>
</linearGradient>
</defs>
</svg>
`,
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.3223 16.1213C18.3223 17.2721 17.3898 18.2046 16.2389 18.2046H5.4056C4.25518 18.2046 3.32227 17.2721 3.32227 16.1213V5.28792C3.32227 4.13709 4.25518 3.20459 5.4056 3.20459H16.2389C17.3898 3.20459 18.3223 4.13709 18.3223 5.28792V16.1213Z" fill="#673AB7"/>
<path d="M14.5848 11.3713C14.3139 10.9963 13.9223 10.7379 13.4181 10.6004C13.4181 10.6004 13.8431 10.4463 14.2264 9.87126C14.4556 9.50459 14.5723 9.06292 14.5723 8.54626C14.5723 7.65042 14.2473 6.96292 13.5973 6.49209C12.9473 6.02126 12.2139 5.70459 10.9681 5.70459H7.07227V15.7046H11.4181C12.5973 15.6963 13.4848 15.4421 14.0889 14.9546C14.6889 14.4588 14.9889 13.7254 14.9889 12.7463C14.9889 12.2046 14.8556 11.7463 14.5848 11.3713ZM9.57227 7.37126C9.57227 7.37126 11.3098 7.37126 11.3431 7.37126C11.9764 7.37126 12.4889 7.88376 12.4889 8.51709C12.4889 9.15042 11.9764 9.66292 11.3431 9.66292C11.3098 9.66292 9.57227 9.66292 9.57227 9.66292V7.37126ZM11.6556 14.0379H9.57227V11.5379H11.6556C12.3473 11.5379 12.9056 12.0963 12.9056 12.7879C12.9056 13.4796 12.3473 14.0379 11.6556 14.0379Z" fill="white"/>
</svg>
`,
          ],
        },
        {
          id: 5,
          tech: ["app"],
          image: "axxios.png",
          project_name: "Axxios",
          short_desc: `Lights to music and everything in
between, axxios makes all of your devices smarter. Axxios home is a privacy-focused, voice-activated smart home control system. From your lights to your music and everything in
between, axxios makes all of your devices smarter.`,
          path: "/axxios",
          technologyUsed: [
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.2085 7.93652L8.01979 4.18652H1.45312L10.2085 19.1865L18.964 4.18652H12.3973L10.2085 7.93652Z" fill="#81C784"/>
<path d="M12.3985 4.18652L10.2098 7.93652L8.02104 4.18652H4.85938L10.2098 13.3532L15.5602 4.18652H12.3985Z" fill="#455A64"/>
</svg>
`,
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_308_802)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.3253 0.657557C12.1812 0.657557 12.0466 0.688266 11.9237 0.728424C12.1871 0.905593 12.3312 1.13591 12.4045 1.3993C12.4092 1.43474 12.4198 1.46072 12.4245 1.49734C12.4293 1.53395 12.4363 1.55876 12.4363 1.59183C12.4576 2.04656 12.3182 2.10325 12.219 2.37137C12.069 2.71744 12.1104 3.08949 12.2899 3.38714C12.3063 3.42698 12.3269 3.46499 12.3513 3.50053C12.1552 2.1942 13.2454 1.99695 13.4462 1.58946C13.4616 1.23276 13.1675 0.995358 12.9348 0.830001C12.7127 0.695353 12.5096 0.652832 12.3253 0.652832V0.657557ZM13.9671 0.952838C13.9458 1.07095 13.9624 1.04024 13.9553 1.10284L13.9435 1.23749L13.908 1.36151C13.8962 1.40285 13.882 1.44419 13.8667 1.48553L13.81 1.60364C13.7946 1.6249 13.784 1.64498 13.7687 1.66506L13.7379 1.7123L13.66 1.81506C13.6293 1.84577 13.6033 1.88238 13.5655 1.90955C13.5277 1.93672 13.5041 1.97097 13.4675 1.99695C13.3588 2.07963 13.2348 2.14105 13.1214 2.219C13.086 2.24499 13.0505 2.26625 13.0186 2.29696C12.9837 2.32169 12.9509 2.34935 12.9206 2.37964C12.8852 2.41035 12.8592 2.44106 12.8261 2.47767C12.793 2.51429 12.7694 2.545 12.7482 2.58043L12.6773 2.68909L12.6206 2.80721L12.5793 2.92532L12.5438 3.05524C12.5391 3.0765 12.5391 3.10249 12.532 3.12257C12.5249 3.14264 12.5273 3.1639 12.5202 3.18398L12.5155 3.31391C12.5155 3.34462 12.5155 3.37533 12.5202 3.4084C12.5202 3.44974 12.5249 3.49108 12.5356 3.53832C12.5462 3.58557 12.5509 3.621 12.5615 3.66234L12.6029 3.78636C12.6147 3.81234 12.6289 3.83833 12.6383 3.85723L11.4501 3.39659L10.8513 3.24304L10.5253 3.16509C10.2144 3.10312 9.90061 3.0566 9.58511 3.02571C9.5733 3.02571 9.56976 3.02099 9.55913 3.02099L8.6343 2.97374L7.95752 2.99973C7.64216 3.02099 7.3268 3.06115 7.01262 3.11312L6.77994 3.15446L6.31457 3.25721L6.08189 3.31863L5.85984 3.41667L5.68976 3.49462C5.67795 3.49934 5.6685 3.49934 5.66377 3.50643L5.51968 3.5773C5.50432 3.58202 5.49369 3.58911 5.48424 3.59265L5.32361 3.67533C5.28818 3.69069 5.25274 3.71077 5.22085 3.7273C5.2055 3.73911 5.18542 3.74738 5.17361 3.75329L5.03896 3.83124C4.99619 3.85487 4.95478 3.8809 4.91494 3.9092L4.81218 3.98006L4.69879 4.06274L4.61139 4.13361C4.59958 4.13833 4.59013 4.14896 4.58068 4.15487L4.50273 4.22219C4.498 4.234 4.48737 4.23755 4.48147 4.24345L4.38698 4.33086L4.28422 4.42889L4.19682 4.52338C4.185 4.53519 4.17083 4.54464 4.16138 4.55409C4.13363 4.58646 4.10447 4.61759 4.07398 4.6474C4.06925 4.65921 4.05862 4.66275 4.05272 4.67338L3.93461 4.7974L3.65586 5.06552C3.56137 5.1482 3.46452 5.22615 3.36648 5.29229L3.05703 5.48836C2.95427 5.54505 2.84443 5.59702 2.73104 5.64191C2.62128 5.6886 2.50934 5.72999 2.3956 5.76592C2.17827 5.81317 1.95622 5.90057 1.76488 5.91593C1.72354 5.91593 1.67747 5.92774 1.63495 5.93128L1.50503 5.96199L1.38101 6.00924C1.33873 6.02599 1.29733 6.04491 1.25699 6.06593C1.22156 6.09192 1.17904 6.11318 1.14361 6.1368C1.10817 6.16042 1.07274 6.19349 1.04085 6.2242C1.00896 6.25491 0.96998 6.28562 0.93809 6.31869L0.850687 6.42145C0.824702 6.46279 0.793993 6.4994 0.772732 6.53956C0.7457 6.57743 0.721614 6.61731 0.700684 6.65886L0.64399 6.7935L0.596745 6.92815L0.57076 7.05217C0.555405 7.11359 0.555405 7.17619 0.5495 7.20572C0.543594 7.23525 0.5495 7.27422 0.5495 7.31084C0.548496 7.33339 0.550082 7.35597 0.554224 7.37816C0.558949 7.4136 0.566035 7.44549 0.575484 7.4762L0.610918 7.57069C0.626273 7.60612 0.646352 7.63801 0.667612 7.66872L0.734936 7.76321L0.82234 7.84589C0.852617 7.87617 0.885412 7.90383 0.920373 7.92857C1.04439 8.03723 1.07392 8.07266 1.23573 8.15534C1.26172 8.1707 1.2877 8.18133 1.31841 8.19668C1.33377 8.21204 1.33377 8.21676 1.33967 8.22739C1.3444 8.26873 1.35503 8.31007 1.36566 8.35141C1.37552 8.39395 1.38936 8.43547 1.407 8.47543L1.44834 8.56992C1.45306 8.58173 1.46015 8.59118 1.46369 8.5959L1.52511 8.70929L1.60306 8.81795L1.69047 8.91599C1.72118 8.9467 1.75189 8.97268 1.7885 9.00339L1.89126 9.08134C1.92669 9.10733 1.96213 9.12859 2.00465 9.14867C2.04286 9.17067 2.08275 9.18963 2.12394 9.20536C2.15465 9.22072 2.19126 9.23135 2.2267 9.2408C2.26213 9.25025 2.29402 9.26206 2.3141 9.26678C2.29875 9.54553 2.29284 9.8101 2.33536 9.90223C2.38261 10.005 2.60938 9.68962 2.83616 9.32938C2.80545 9.68608 2.78419 10.1042 2.83616 10.227C2.88813 10.3499 3.20231 9.95302 3.4716 9.50891C7.13309 8.66205 10.4757 11.1932 10.8265 14.7673C10.7591 14.2098 10.0729 13.8992 9.75756 13.9759C9.60401 14.3586 9.33944 14.85 8.91541 15.1535C8.95085 14.811 8.93549 14.4614 8.86344 14.12C8.7479 14.5955 8.52936 15.0398 8.22327 15.4216C7.73311 15.4571 7.24294 15.2208 6.98309 14.8641C6.96183 14.8488 6.95711 14.8169 6.94175 14.7968L6.90041 14.6881C6.88506 14.6527 6.87443 14.6173 6.8697 14.5795C6.86498 14.5417 6.86498 14.5086 6.86498 14.4661V14.3881C6.8697 14.3527 6.88033 14.3173 6.89096 14.2795L6.9264 14.1708C6.94766 14.1354 6.96183 14.0999 6.98782 14.0622C7.07522 13.8259 7.07522 13.6133 6.91695 13.4952C6.88624 13.474 6.85553 13.4598 6.81891 13.4432C6.79765 13.4385 6.77167 13.4279 6.75159 13.422L6.71025 13.4066L6.60159 13.3806C6.56627 13.3704 6.52969 13.3653 6.49292 13.3653C6.45541 13.3592 6.41753 13.3556 6.37954 13.3547C6.35355 13.3547 6.32757 13.3594 6.30158 13.3594C6.26325 13.3591 6.22506 13.3642 6.18819 13.3747L6.07953 13.3948L5.97087 13.4302L5.86811 13.4775L5.77007 13.5295C4.56533 14.3149 5.28581 16.1516 6.10551 16.6854C5.79606 16.7421 5.47952 16.8095 5.3933 16.8768C5.6059 17.0209 5.8374 17.1366 6.08071 17.2335L6.91695 17.4697C7.3457 17.5642 7.77917 17.5937 8.21855 17.5677C9.33464 17.486 10.3894 17.0257 11.2083 16.2631C12.0273 15.5004 12.5613 14.481 12.7222 13.3736L12.7529 13.5082L12.8001 13.7976L12.8214 13.937L12.8332 14.0905L12.845 14.2606V14.3433C12.845 14.3692 12.8497 14.4 12.8497 14.4259C12.8497 14.4519 12.845 14.4874 12.845 14.5204V14.5913C12.845 14.6267 12.8403 14.6586 12.8403 14.6941C12.8403 14.7141 12.8403 14.7354 12.8356 14.7614L12.8308 14.8748C12.8261 14.8901 12.8261 14.9055 12.8261 14.922L12.8108 15.0401C12.8108 15.0555 12.8108 15.0708 12.806 15.0874L12.786 15.2374V15.2492L12.7553 15.3933L12.7245 15.5468L12.6832 15.7075L12.6419 15.8681L12.5899 16.0334L12.4765 16.3335L12.4151 16.4835L12.3442 16.6276C12.3395 16.6429 12.3324 16.6535 12.3289 16.663C11.9828 17.3551 11.4867 17.9504 10.8666 18.4134C10.8253 18.4394 10.784 18.4701 10.7426 18.5008C10.7308 18.5126 10.7166 18.5162 10.7072 18.5268L10.5938 18.6048L10.6091 18.6355H10.6139L10.8312 18.6048H10.8359L11.2375 18.5339C11.2729 18.5292 11.3155 18.5185 11.3509 18.5079L11.4218 18.4926L11.5304 18.4725L11.6249 18.4465C12.1411 18.3225 12.6407 18.1512 13.1226 17.9504C12.3017 19.0725 11.2009 19.9749 9.91464 20.569C10.5088 20.5276 11.1029 20.4296 11.6745 20.2642C13.7557 19.6501 15.5073 18.2504 16.5561 16.3642C16.3434 17.5601 15.8691 18.6942 15.1671 19.6855C15.6679 19.3548 16.1274 18.9733 16.5467 18.5398C17.7027 17.3327 18.4615 15.8007 18.7211 14.1496C18.8983 14.9645 18.9479 15.8079 18.8711 16.6394C22.5999 11.4377 19.1806 6.04467 17.7491 4.62496C17.7443 4.61315 17.7372 4.6096 17.7372 4.59897C17.7254 4.66039 17.7219 4.72299 17.7172 4.78441C17.7018 4.90252 17.6865 5.01709 17.6652 5.13048C17.6439 5.24387 17.6085 5.35726 17.5778 5.47301C17.5471 5.58876 17.4998 5.69506 17.4538 5.80372C17.4077 5.91238 17.3557 6.01632 17.3002 6.11908C17.2433 6.22011 17.1814 6.31826 17.1148 6.41318C17.0475 6.51122 16.9754 6.60452 16.9022 6.69193C16.8251 6.78184 16.7439 6.86815 16.6589 6.95059C16.6069 6.99784 16.5608 7.038 16.5089 7.08052L16.3908 7.18328C16.2985 7.25645 16.2019 7.3239 16.1014 7.38525C16.0028 7.44887 15.9011 7.50761 15.7967 7.56124C15.688 7.61321 15.5793 7.65927 15.4707 7.70533C15.3607 7.74696 15.2487 7.78322 15.1352 7.814C15.0218 7.84471 14.9025 7.87069 14.7892 7.89195C14.6758 7.91321 14.5529 7.92266 14.4384 7.93329C14.3557 7.93801 14.273 7.9451 14.2021 7.9451C14.084 7.9451 13.9659 7.93329 13.8513 7.92384C13.7368 7.91439 13.6151 7.89786 13.4994 7.87187C13.3821 7.85067 13.2665 7.82147 13.1533 7.78447H13.1486C13.262 7.77266 13.3753 7.76321 13.4911 7.74313C13.6068 7.72305 13.7238 7.69588 13.8372 7.66518C13.9506 7.63447 14.0639 7.59785 14.1726 7.55651C14.2813 7.51517 14.3947 7.46202 14.4986 7.41241C14.6045 7.3608 14.7077 7.30403 14.808 7.24233C14.9061 7.17501 15.0041 7.10768 15.0974 7.03564C15.19 6.96362 15.2779 6.88591 15.3608 6.80295C15.4482 6.725 15.5262 6.6376 15.6041 6.55019C15.6821 6.46279 15.7541 6.36476 15.8215 6.27145C15.8333 6.25609 15.8427 6.23601 15.8522 6.21948L16.0022 5.98325C16.0589 5.88049 16.1108 5.77656 16.1557 5.66789C16.2006 5.55923 16.2431 5.45056 16.2797 5.33718C16.3163 5.22379 16.3411 5.11512 16.3671 5.00174C16.3931 4.88835 16.4085 4.76905 16.4191 4.65567C16.4297 4.54228 16.4392 4.41944 16.4392 4.30487C16.4392 4.22219 16.4345 4.13951 16.4274 4.06865C16.4156 3.95053 16.4014 3.83597 16.386 3.72258C16.3655 3.60606 16.3395 3.49058 16.3081 3.37651C16.2726 3.26784 16.2372 3.15446 16.1947 3.04579C16.1522 2.93713 16.1002 2.82847 16.0506 2.72689C16.001 2.62531 15.9372 2.52019 15.8734 2.42216C15.8096 2.32412 15.7388 2.23082 15.6667 2.13869L15.4305 1.8753C15.3869 1.83109 15.342 1.78816 15.2959 1.74655C15.0644 1.56667 14.8248 1.39759 14.5777 1.23985C14.5423 1.21977 14.5104 1.20442 14.475 1.18788C14.3049 1.07922 14.1443 1.02252 13.9848 0.970555L13.9671 0.952838Z" fill="#EA2845"/>
</g>
<defs>
<clipPath id="clip0_308_802">
<rect width="20" height="20" fill="white" transform="translate(0.550781 0.618652)"/>
</clipPath>
</defs>
</svg>
`,
          ],
        },
        {
          id: 6,
          tech: ["web"],
          image: "conduk.png",
          project_name: "Conduktor",
          short_desc: `Development of End-to-End Subscription Management on Conduktor. Conduktor help companies operate their data using Apache Kafka via an Apache Kafka Desktop Client, allowing their users with conclusive ease.`,
          path: "/conduktor",
          technologyUsed: [
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.2085 7.93652L8.01979 4.18652H1.45312L10.2085 19.1865L18.964 4.18652H12.3973L10.2085 7.93652Z" fill="#81C784"/>
<path d="M12.3985 4.18652L10.2098 7.93652L8.02104 4.18652H4.85938L10.2098 13.3532L15.5602 4.18652H12.3985Z" fill="#455A64"/>
</svg>
`,
            `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5886 10.8568C10.1728 10.1864 9.87111 9.63059 9.45319 8.58393C8.74652 6.81601 13.7511 5.21851 11.7219 2.14893C12.6015 4.26934 8.56486 5.58018 8.18986 7.34601C7.84694 8.97018 10.5865 10.8568 10.5886 10.8568Z" fill="#F44336"/>
<path d="M10.6842 7.67851C10.6042 8.72684 11.613 9.28559 11.6421 10.0514C11.6655 10.6748 11.0392 11.1943 11.0392 11.1943C11.0392 11.1943 12.1759 10.971 12.5305 10.0202C12.9242 8.96434 11.7663 8.24143 11.8855 7.39601C11.9967 6.58851 14.3984 5.08643 14.3984 5.08643C14.3984 5.08643 10.8646 5.32059 10.6842 7.67851Z" fill="#F44336"/>
<path d="M14.102 10.9223C14.8328 10.7582 15.4491 11.2236 15.4491 11.7598C15.4491 12.9686 13.7736 14.1111 13.7736 14.1111C13.7736 14.1111 16.3674 13.8019 16.3674 11.8173C16.3674 10.5048 15.0936 10.1769 14.102 10.9223ZM12.8707 11.8973C12.8707 11.8973 13.6795 11.3211 13.8949 11.1048C11.9103 11.5261 7.37906 11.5828 7.37906 11.2169C7.37906 10.8798 8.84031 10.5344 8.84031 10.5344C8.84031 10.5344 5.60156 10.4878 5.60156 11.4432C5.60156 12.439 9.84115 12.5103 12.8707 11.8973Z" fill="#1565C0"/>
<path d="M12.3736 12.8039C10.4949 13.4285 7.03448 13.2289 8.05948 12.3901C7.56031 12.3901 6.82031 12.7914 6.82031 13.1772C6.82031 13.951 10.5628 14.5485 13.3328 13.4156L12.3736 12.8039Z" fill="#1565C0"/>
<path d="M8.5194 14.124C7.83773 14.124 7.39648 14.5632 7.39648 14.8832C7.39648 15.8794 11.4632 15.9799 13.0744 14.9686L12.0502 14.2886C10.8465 14.8178 7.82273 14.8907 8.5194 14.124Z" fill="#1565C0"/>
<path d="M15.8515 15.7462C15.8515 15.3562 15.4119 15.1725 15.2544 15.0845C16.1827 17.3233 5.95563 17.1495 5.95563 15.8279C5.95563 15.5275 6.70854 15.2333 7.40437 15.3725L6.81271 15.0229C5.42604 14.8054 4.48438 15.415 4.48438 15.9066C4.48438 18.1995 15.8515 18.0891 15.8515 15.7462Z" fill="#1565C0"/>
<path d="M16.9836 16.5679C15.2561 18.2741 10.8757 18.8958 6.4707 17.8416C10.8757 19.7179 16.9628 18.6612 16.9836 16.5679Z" fill="#1565C0"/>
</svg>

`,
          ],
        },
        {
          id: 7,
          tech: ["design"],
          image: "bigscoot-ui.png",
          project_name: "BIGSCOOTS",
          short_desc: `BigScoots is an IT organization that provides web hosting and server management.`,
          path: "/bigscoot-ui",
        },
        {
          id: 8,
          tech: ["app", "design"],
          image: "green-tensor.png",
          project_name: "Green Tensor",
          short_desc: `smart home app that aims to streamline the monitoring and control of various smart home devices.`,
          path: "/gtensor",
        },
        {
          id: 9,
          tech: ["design", "marketing"],
          image: "bebambi.jpg",
          project_name: "Bebambi",
          short_desc: `Guiding you through every milestone of parenthood,
          from conception to childhood.`,
          path: "/bebambi",
        },
        {
          id: 10,
          tech: ["design"],
          image: "ready.png",
          project_name: "Ready",
          short_desc: `smart home app that aims to streamline the monitoring and control of various smart home devices.`,
          path: "/ready",
        },
        {
          id: 11,
          tech: ["design"],
          image: "bayked.png",
          project_name: "Bayked",
          short_desc: `Bayked partners with pizzerias to promote local food, with easy ordering and tracking features.`,
          path: "/bayked",
        },
        {
          id: 12,
          tech: ["design","app"],
          image: "sereniby.png",
          project_name: "Sereniby",
          short_desc: `Giving your little ones pure air with a single tap`,
          path: "/sereniby",
        },
        {
          id: 13,
          tech: ["design"],
          image: "bilal.png",
          project_name: "Bilal",
          short_desc: `Stay Connected with Faith through Bilal App's Namaz Alerts and Quran Recitations`,
          path: "/bilal",
        },
        {
          id: 14,
          tech: ["design"],
          image: "listen.png",
          project_name: "Listen",
          short_desc: `AI based chatbot to make you feel valued and have empathetic discussions`,
          path: "/listen",
        },
        {
          id: 15,
          tech: ["design"],
          image: "smart.png",
          project_name: "Smart Interview Coach",
          short_desc: `AI Interview coaching platform, ranking you on 20+ parameters`,
          path: "/smart-interview-coach",
        },
        {
          id: 16,
          tech: ["app"],
          image: "primal-thumbnail.png",
          project_name: "Primal Plunge",
          short_desc: `Control cold plunge chillers, track sessions, and access wellness content with real-time Tuya-powered connectivity`,
          path: "/PrimalPlunge",
        },
        {
          id: 17,
          tech: ["app"],
          image: "cayka-thumbnail.png",
          project_name: "Cayka",
          short_desc: `Control and monitor smart devices via Wi-Fi, Bluetooth, and MQTT with real-time access and customization.`,
          path: "/Cayka",
        },
        {
          id: 18,
          tech: ["web"],
          image: "zimi-thumbnail.png",
          project_name: "Zimi",
          short_desc: `Zimi offers eco-friendly smart home tech with a simple app that integrates devices for smarter living.`,
          path: "/Zimi",
        },
        {
          id: 19,
          tech: ["web"],
          image: "simi-thumbnail.png",
          project_name: "Simi Connect",
          short_desc: `Simi Connect’s Simi Smart app lets users control home appliances like bulbs, cameras, and thermostats.`,
          path: "/SimiConnect",
        },
      ],
      isCurrent: "all",
    };
  },
  mounted() {
    scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // this.getFilter();
  },
  methods: {
    // getFilter() {
    //   this.$root.$emit("eventing", this.projects);
    // },
    changeFilter(by) {
      this.isCurrent = by;
    },
    async downloadFile() {
      const res = await this.downloadPdf();
      const a = document.createElement("a");
      a.download = "SeptemSystems-Profile.pdf";
      a.target = "_blank";
      a.href = res;
      a.click();
    },
    async downloadPdf() {
      return new Promise((resolve, reject) => {
        try {
          var fileName = "SeptemSystems-Profile.pdf";
          var url = "assets/files/" + fileName;
          let xhr = new XMLHttpRequest();
          xhr.onload = function () {
            let reader = new FileReader();
            reader.onloadend = function () {
              resolve(reader.result);
            };
            reader.readAsDataURL(xhr.response);
          };
          xhr.open("GET", url);
          xhr.responseType = "blob";
          xhr.send();
        } catch (e) {
          reject(e.message);
        }
      });
    },
  },
  computed: {
    projectsToShow() {
      return this.projects;
    },
    projectCount() {
      return this.projects.length;
    },
    filteredProjects() {
      if (this.isCurrent === "web") {
        return this.projects.filter((project) => project.tech.includes("web"));
      }
      if (this.isCurrent === "app") {
        return this.projects.filter((project) => project.tech.includes("app"));
      }
      if (this.isCurrent === "design") {
        return this.projects.filter((project) =>
          project.tech.includes("design")
        );
      }

      if (this.isCurrent === "marketing") {
        return this.projects.filter((project) =>
          project.tech.includes("marketing")
        );
      }
      return this.projects;
    },
  },
};
</script>
<style scoped>
.sub-heading {
  text-transform: capitalize;
  text-align: center;
  position: relative;
  font-weight: 700;
}
.line {
  display: block;
  margin: -0.5em 50% 3em;
  transform: translateX(-50%);
  width: 16em;
  height: 3px;
  background-color: #00b398;
}
.block-display {
  display: block;
  width: 80%;
  padding: 0.01em 0.5em;
  border-radius: 1em;
  background-color: #1a1a1a;
  margin: 2em auto 5em;
}
.block-display .flex {
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5em 0;
}
.portfolio-card-body-image {
  margin-bottom: 2em !important;
}
.flex button {
  background-color: transparent;
  border: none;
  display: block;
  width: 25%;
  outline: none;
  text-transform: capitalize;
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  background-color: none;
  padding: 1em 2.5em;
  border-radius: 0.75em;
}
.custom-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
}
.custom-grid .portfolio-card-image-container,
.custom-grid .portfolio-card-home-image-container {
  width: 100%;
}

.overlay {
  cursor: pointer;
}
.flex .active {
  background-color: #00b398;
}

@media (max-width: 1400px) {
  .block-display {
    width: 100% !important;
  }
  .flex button {
    padding: 0.75em 2em;
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .custom-grid {
    grid-template-columns: 1fr;
  }
  .block-display {
    width: 98% !important;
  }
  .block-display .flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1em;
  }
  .block-display .flex button {
    padding: 1em 1.25em;
    font-size: 0.75em !important;
    font-weight: 600;
    width: 100%;
  }
}
@media (max-width: 480px) {
  .block-display {
    width: 100% !important;
  }
  .block-display .flex button {
    font-size: 0.5em;
    padding: 1em 0.75em;
  }
}
</style>
